import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MobileUploadIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 1.33331H4.00002C3.6464 1.33331 3.30726 1.47379 3.05721 1.72384C2.80716 1.97389 2.66669 2.31302 2.66669 2.66665V13.3333C2.66669 13.6869 2.80716 14.0261 3.05721 14.2761C3.30726 14.5262 3.6464 14.6666 4.00002 14.6666H12C12.3536 14.6666 12.6928 14.5262 12.9428 14.2761C13.1929 14.0261 13.3334 13.6869 13.3334 13.3333V4.66665L10 1.33331Z"
        stroke={fillColor || '#9D9DA6'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33331 1.33331V3.99998C9.33331 4.3536 9.47379 4.69274 9.72384 4.94279C9.97389 5.19284 10.313 5.33331 10.6666 5.33331H13.3333"
        stroke={fillColor || '#9D9DA6'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 8V12" stroke={fillColor || '#9D9DA6'} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 10L8 8L6 10" stroke={fillColor || '#9D9DA6'} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export { MobileUploadIcon };
